export const routeConfig = {
  meta: {
    title: '账单管理',
  },
  redirect: '/bill/list',
};
